import { graphql, useStaticQuery } from "gatsby";
import React, { useEffect, useMemo, useState } from "react";
import Button from "../atoms/button";
import SiteModal from "../modal";
import IntroModule from "../molecules/intro-module";
import Parser, { attributesToProps } from "html-react-parser";
import BookletLine from "../atoms/booklet-line";
import { social } from "../../utility/constants";
import classNames from "classnames";

export const sortBoxes = (a, b) => {
  const posA = parseInt(a.position?.length ? a.position[0] : 0);
  const posB = parseInt(b.position?.length ? b.position[0] : 0);
  return !isNaN(posA) && !isNaN(posB)
    ? posA - posB
    : isNaN(posA) && isNaN(posB)
    ? 0
    : isNaN(posA)
    ? 1
    : -1;
};

const AssistanceTrigger = ({ node, attribs, onClick }) => {
  const handleClick = (e) => {
    e.preventDefault();
    onClick(e);
  };
  return (
    <a href="/" {...attributesToProps(attribs)} onClick={handleClick}>
      {node.children[0].data}
    </a>
  );
};

export const LineModal = ({ open, onClose }) => {
  const [line, setLine] = useState("");
  const handleChangeLine = (event) => {
    setLine(event.target.value.split("_")[0]);
  };
  useEffect(() => {
    if (!open) {
      setLine("");
    }
  }, [open]);
  const {
    liferayBooklet: { lines },
  } = useStaticQuery(graphql`
    {
      liferayBooklet {
        lines {
          ... on LiferayLinesMultivalue {
            selectGroups {
              label
              options {
                label
                value
              }
            }
          }
        }
      }
    }
  `);

  return (
    <SiteModal
      show={open}
      buttonClose={true}
      onHide={onClose}
      className="compare-modal assistance-modal"
    >
      <BookletLine
        currentLine={line}
        handleChangeLine={handleChangeLine}
        lineOptions={lines.selectGroups}
      />
    </SiteModal>
  );
};

const AssistanceSection = ({ data, isFirst }) => {
  const boxes = useMemo(() => data.box.sort(sortBoxes), [data]);

  const [lineModalVisible, setLineModalVisible] = useState(false);
  const showLineModal = () => setLineModalVisible(true);
  const closeLineModal = () => setLineModalVisible(false);

  return (
    <>
      <div
        className={classNames(
          "assistance__grid",
          boxes.filter((item) => item.title || item.description).length === 1 &&
            "assistance__grid--single"
        )}
      >
        {data.sectionTitle ? (
          <IntroModule title={data.sectionTitle} isFirst={isFirst}></IntroModule>
        ) : null}
        {boxes
          .filter((item) => item.title || item.description)
          .map((box, i) => (
            <>
              <div className="assistance-box" key={i}>
                <h3 className="assistance-box--title">{box.title}</h3>
                <p>
                  {Parser(box.description, {
                    replace: (node) => {
                      if (node.type === "tag" && node.attribs.id === "picklist") {
                        return (
                          <AssistanceTrigger
                            node={node}
                            attribs={node.attribs}
                            onClick={showLineModal}
                          />
                        );
                      }
                    },
                  })}
                </p>
                {box.cta && box.cta.length > 0 && (
                  <div className="assistance-box__cta-container ">
                    {box.cta
                      .filter((item) => item.link)
                      .map((item, j) => (
                        <Button
                          key={j}
                          data={item}
                          iconName={
                            social.includes(item.icon.icon[0])
                              ? "social-" + item.icon.icon[0]
                              : item.icon.icon[0]
                          }
                          icon={item.icon.alternativeIcon ? item.icon : null}
                          className={classNames(
                            "assistance-box__cta-button primary blue",
                            (item.color?.[0] === "white" || j > 1) && "alternate",
                            item.type?.[0] === "video" && "open-modal video"
                          )}
                        ></Button>
                      ))}
                  </div>
                )}
              </div>
              <LineModal open={lineModalVisible} onClose={closeLineModal} />
            </>
          ))}
      </div>
    </>
  );
};

export default AssistanceSection;
export const fragment = graphql`
  fragment AssistanceSectionFragment on LiferayAssistanceSection {
    id
    anchorDesktop
    anchorMobile
    sectionTitle
    box {
      title
      position
      description
      cta {
        color
        link
        target
        label
        icon {
          width
          icon
          height
          alternativeIcon {
            value {
              description
            }
            node {
              publicURL
              resize {
                src
              }
            }
          }
        }
      }
    }
  }
`;
